module.exports = __webpack_public_path__ + "img/signal_wifi_0_bar.e87da462.svg";